import _ from 'lodash';
import { PRIMARY } from '../../constants/Colors';
import { Avatar, IconButton, Tooltip } from '@mui/material';

export interface BakeasyIconButtonProps {
  color?: any | 'default';
  label?: string;
  disabled?: boolean;
  icon?: any;
  tooltipTitle?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function stringAvatar(name: any) {
  return { sx: { bgcolor: PRIMARY }, children: `${_.capitalize(name?.slice(0, 1))}` };
}

export function BakeasyIconButton(props: BakeasyIconButtonProps) {
  return (
    <Tooltip title={props.tooltipTitle}>
      {props?.icon ? (
        <IconButton color={props.color} size="small" onClick={props.onClick}>
          {props?.icon}
        </IconButton>
      ) : (
        <IconButton color={props.color} onClick={props.onClick}>
          <Avatar {...stringAvatar(props?.label?.toString())}></Avatar>
        </IconButton>
      )}
    </Tooltip>
  );
}
